import _ from "lodash";
import $ from "jquery";
import { useEffect, useState } from "react";
import { Button, Checkbox, Dropdown, Form, FormProps, Icon, Input, Modal, Segment, Table } from "semantic-ui-react";
import { ModalControlData, useModalControl } from "../hooks/commonHooks";
import { useFormConnect, useFormData } from "../hooks/formHooks";
import { restRequest } from "../http";
import { AREAS } from "../models/common_model";
import { PageData } from "../models/common_model";
import { LocalServerAuthData } from "../models/user_model";
import { fieldError, formatDateTime } from "../utils";
import { Page } from "./commons/Page";
import { useCurrentUser } from "../hooks/auth-hook";
import { dialogControl } from "../controls/dialog-control";

export function LocalServerAuthComponent(props: {}) {
    const currentUser = useCurrentUser();
    const [searchData, setSearchField] = useFormData<any>({});
    const [auths, setSearchData] = useFormConnect<any, PageData<LocalServerAuthData>>({}, 'local_server_auth/search');

    const editModalControl = useModalControl<boolean>(false);
    const [currentEditId, setCurrentEditId] = useState<number>();
    const [reloadNumber, setReloadNumber] = useState(0);


    return <>
        <Segment.Group>
            <Segment attached="top">
                <Form onSubmit={e => setSearchData(searchData)}>
                    <Form.Group>
                        <Form.Field inline>
                            <Input placeholder="Name" name="name" value={searchData['name'] || ''} onChange={setSearchField} />
                        </Form.Field>

                        <Form.Field inline>
                            <Input placeholder="Product" name="product" value={searchData['product'] || ''} onChange={setSearchField} />
                        </Form.Field>

                        <div><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <th>Name</th>
                            <th>Products</th>
                            <th>SSH Address</th>
                            <th>Created By</th>
                            <th>Created At</th>
                            <th><Button color="blue" icon="add" content="Local Server Auth" size="mini" onClick={e => {
                                setCurrentEditId(undefined);
                                editModalControl.data = false;
                                editModalControl.setOpen(true);
                            }} /></th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {auths?.items.map(auth => {
                            return <tr key={auth.id}>
                                <td>{auth.name}</td>
                                <td>{(auth.products || []).join(', ')}</td>
                                <td>
                                    {auth.ssh_address}
                                    <Button onClick={e => {
                                        e.preventDefault();
                                        $(e.target).addClass('loading');
                                        restRequest(`local_server_auth/ngrok_status/${auth.id}`, {'status': auth.ssh_address ? 'stop' : 'start'}, 'post').then(() => {
                                            const waiting: (time: number) => Promise<string> = (time: number) => {
                                                return restRequest<string>(`local_server_auth/check_ngrok_status/${auth.id}`).then(result => {
                                                    if (result === 'waiting') {
                                                        return new Promise<string>((resolve, reject) => {
                                                            setTimeout(() => resolve(waiting(time + 1)), 5000);
                                                        });
                                                    } else {
                                                        setSearchData((d: any) => ({...d, refreshCode : (d.refreshCode || 0) + 1}));
                                                        return '';
                                                    }
                                                })
                                            }
                                            return waiting(0);

                                        }).finally(() => {
                                            $(e.target).removeClass('loading');
                                        });

                                    }} as="a" size="mini" compact>{auth.ssh_address ? 'stop ngrok' : 'start ngrok'}</Button>
                                </td>
                                <td>{auth.created_by_name}</td>
                                <td>{formatDateTime(auth.created_at)}</td>
                                <td>
                                    <Button onClick={e => {
                                        setCurrentEditId(auth.id);
                                        editModalControl.data = !currentUser.permissions.local_server_auth.update;
                                        editModalControl.setOpen(true);
                                    }} color="blue" icon="edit" size="mini" />

                                    {currentUser.permissions.local_server_auth.delete && <Button onClick={e => {
                                        dialogControl.deletionConfirm(auth.name, argee => {
                                            if (argee) {
                                                return restRequest(`local_server_auth/${auth.id}`, null, 'delete').then(() => {
                                                    setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
                                                })
                                            }
                                            return Promise.resolve()
                                        })
                                    }} color="red" icon="delete" size="mini" />}
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={auths} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>

        <Editor id={currentEditId} modalControl={editModalControl} onFinish={result => {
            setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
            editModalControl.setOpen(false)
            setReloadNumber(n => n + 1);
        }}></Editor>
    </>
}

function Editor(props: { id?: number, allRoles?: { id: number, name: string }[], modalControl: ModalControlData<boolean>, onFinish: (data: LocalServerAuthData) => void }) {
    const { id, allRoles, modalControl, onFinish } = props;
    const isCreate = !id;
    const isReadonly = modalControl.data;

    const [data, setField, setData] = useFormData<LocalServerAuthData>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState<string[]>([]);
    const [hidePassword, setHidePassword] = useState(true);

    useEffect(() => {
        setData({ refresh_password: false } as any);
        setHidePassword(true);
        setInvalidError({});
        if (id) {
            setLoading(true);
            restRequest<LocalServerAuthData>('local_server_auth/' + id).then(setData).finally(() => setLoading(false))
        }
    }, [id]);

    useEffect(() => {
        restRequest<string[]>('svn_repository/products').then(setProducts)
    }, []);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.preventDefault();

        setLoading(true);

        restRequest<LocalServerAuthData>(`local_server_auth/${isCreate ? '' : id}`, data, isCreate ? 'post' : 'put').then(result => {
            setData(result);
            onFinish(result);
            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }


    return <>
        <Modal {...modalControl.props} size="large">
            <Modal.Header>{isCreate ? 'Create' : 'Update'} Local Server Auth </Modal.Header>
            <Modal.Content>
                <Form onSubmit={onSubmit} loading={loading}>

                    <Form.Group widths="equal">
                        <Form.Input label="Name" name="name" value={data['name'] || ''} onChange={setField} required error={fieldError('name', invalidError)} readOnly={isReadonly} autoFocus>
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="Allow Products">
                            <Dropdown multiple name="products" allowAdditions additionPosition="top" value={data.products || []} onChange={isReadonly ? undefined : setField} options={_.uniq([...products, ...data.products || []]).map(p => ({ key: p, text: p, value: p }))}  
                            onAddItem={(e, d) => {
                                if (d.value && !products.find(p => p.toUpperCase() === d.value)) {
                                    setProducts(ps => [...ps, d.value as string]);
                                }
                            }} search selection fluid></Dropdown>
                        </Form.Input>
                    </Form.Group>
                    {!isCreate && <Form.Group widths="equal">
                        <Form.Input value={data.password} type={hidePassword ? 'password' : 'text'}
                            icon={<Icon name={hidePassword ? 'eye slash' : 'eye'} link onClick={() => setHidePassword(p => !p)} />}
                        />
                        <Form.Input label="Refresh Password">
                            <Checkbox checked={data.refresh_password} onChange={(e, d) => setField(null, { name: 'refresh_password', value: !data.refresh_password })} readOnly={isReadonly}></Checkbox>
                        </Form.Input>
                    </Form.Group>}
                    <div>
                        {!isReadonly && <Button primary>Submit</Button>}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button as="a" onClick={e => modalControl.setOpen(false)}>Cancel</Button>
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    </>
}